import { Breadcrumbs } from "../../../AbstractElements";
import { TagAndPills, UiKits } from "../../../Constant";
import { Container, Row } from "reactstrap";
import BadgesContextualVariationsCart from "./BadgesContextualVariations";
import PillsContextualVariationsCart from "./PillsContextualVariations";
import NumberofBadgeCard from "./NumberofBadge";
import BadgeTagsWithIconsCart from "./BadgeTagsWithIcons";
import NumberOfPillsTagCart from "./NumberOfPillsTag";
import RoundedPillsWithIconsCart from "./RoundedPillsWithIcons";
import BadgeHeadingsExampleCart from "./BadgeHeadingsExample";
import BadgesAsPartButtonsCart from "./BadgesAsPartButtons";

const TagAndPillsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={TagAndPills} parent={UiKits} title={TagAndPills} />
      <Container fluid>
        <Row>
          <BadgesContextualVariationsCart />
          <PillsContextualVariationsCart />
          <NumberofBadgeCard />
          <NumberOfPillsTagCart/>
          <BadgeTagsWithIconsCart/>
          <RoundedPillsWithIconsCart/>
          <BadgeHeadingsExampleCart/>
          <BadgesAsPartButtonsCart/>
        </Row>
      </Container>
    </>
  );
};

export default TagAndPillsContainer;
